<template lang="pug">
.k-promo-reel
  
</template>

<script lang="js">

export default {
  name: 'PromoReelBlock',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.k-promo-reel {
  
}
</style>
